import FootballStatsCategory from "../../../../football/stats/football-stats-category";
import FootballState from "../../../../football/state/football-state";
import DriveService from "../../../../../services/drive-service";
import StatsRule from "../../../../common/stats-rule";

export default class FlagPatRunStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedState === FootballState.Run &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const tryFragment = play.getFirstFragment(FootballState.PatTry);
        const code = Number(tryFragment.points.option.code);

        return this.addStats({
            gameId: play.gameId,
            playId: play.id,
            period: gameContext.currentPeriod,
            teamId: fragment.runBy.teamId,
            playerId: fragment.runBy.id,
            driveId: await DriveService.resolveDriveId(play, gameContext),
            fragmentId: fragment.id,
            category: FootballStatsCategory.PAT_RUN,
            values: {
                code,
                attempted: 1,
                completed: play.historyContains(FootballState.PatCompleted)
                    ? 1
                    : 0
            }
        });
    }
}
